module.exports = __webpack_public_path__ + "static/media/banner.fa75d1ac.png";